<div *ngIf='contactData' class='InactiveAddContactDialog'>
  <ng-container *ngIf='messages && messages.length > 0'>
    <mat-expansion-panel [expanded]='false'>
      <mat-expansion-panel-header>
        <mat-panel-title>
          Message
        </mat-panel-title>
        <mat-panel-description>Click to expand the message</mat-panel-description>
      </mat-expansion-panel-header>
      <app-message-viewer
        *ngFor='let message of messages'
        [message]='message'
        [sessionData]='sessionData'></app-message-viewer>
    </mat-expansion-panel>
  </ng-container>
  <div *ngIf='formReady' [formGroup]='inputForm' class='InactiveAddContactDialog--form mt-3'>
    <div class='row mb-3'>
      <div class='col col-12'>
        <h5>Add contact</h5>
      </div>
    </div>
    <div class='row mb-3'>
      <div class='col col-12 col-sm-4'>
        <mat-label>Firstname</mat-label>
      </div>
      <div class='col col-12 col-sm-8'>
        <app-text-field formControlName='firstname' type='text'></app-text-field>
      </div>
    </div>
    <div class='row mb-3'>
      <div class='col col-12 col-sm-4'>
        <mat-label>Lastname</mat-label>
      </div>
      <div class='col col-12 col-sm-8'>
        <app-text-field formControlName='lastname' type='text'></app-text-field>
      </div>
    </div>
    <div class='row mb-3'>
      <div class='col col-12 col-sm-4'>
        <mat-label>Email</mat-label>
      </div>
      <div class='col col-12 col-sm-8'>
        <app-text-field formControlName='email' type='text'></app-text-field>
      </div>
    </div>
    <div class='row mb-3'>
      <div class='col col-12 col-sm-4'>
        <mat-label>Company</mat-label>
      </div>
      <div class='col col-12 col-sm-8'>
        <app-text-field formControlName='company' type='text'></app-text-field>
      </div>
    </div>
    <div class='row mb-3'>
      <div class='col col-12 col-sm-4'>
        <mat-label>Company street address</mat-label>
      </div>
      <div class='col col-12 col-sm-8'>
        <app-text-field formControlName='company_address' type='text'></app-text-field>
      </div>
    </div>
    <div class='row mb-3'>
      <div class='col col-12 col-sm-4'>
        <mat-label>Company state</mat-label>
      </div>
      <div class='col col-12 col-sm-8'>
        <app-text-field formControlName='company_state' type='text'></app-text-field>
      </div>
    </div>
    <div class='row mb-3'>
      <div class='col col-12 col-sm-4'>
        <mat-label>Company zipcode</mat-label>
      </div>
      <div class='col col-12 col-sm-8'>
        <app-text-field formControlName='company_zip' type='text'></app-text-field>
      </div>
    </div>
    <div class='row mb-3'>
      <div class='col col-12 col-sm-4'>
        <mat-label>Company country</mat-label>
      </div>
      <div class='col col-12 col-sm-8'>
        <app-text-field formControlName='company_country' type='text'></app-text-field>
      </div>
    </div>
    <div class='row mb-3'>
      <div class='col col-12 col-sm-4'>
        <mat-label>Company URL</mat-label>
      </div>
      <div class='col col-12 col-sm-8'>
        <app-text-field formControlName='company_url' type='text'></app-text-field>
      </div>
    </div>
  </div>
</div>
